import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'

Vue.use(Router)

export default new Router({
  mode: 'history',
  scrollBehavior () {
    return { x: 0, y: 0 }
  },
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home
    },
    {
      path: '/en/home',
      name: 'home-en',
      component: () => import(/* webpackChunkName: "heritage" */ './views/en/Home.vue')
    },
    {
      path: '/mission',
      name: 'mission',
      redirect: {
        name: 'heritage'
      }
    },
    {
      path: '/en/mission',
      name: 'mission-en',
      redirect: {
        name: 'heritage-en'
      }
    },
    {
      path: '/en/mission/heritage',
      name: 'heritage-en',
      component: () => import(/* webpackChunkName: "heritage-en" */ './views/en/Mission/Heritage.vue')
    },
    {
      path: '/mission/heritage',
      name: 'heritage',
      component: () => import(/* webpackChunkName: "heritage" */ './views/Mission/Heritage.vue')
    },
    {
      path: '/en/mission/creation',
      name: 'creation-en',
      component: () => import(/* webpackChunkName: "creation" */ './views/en/Mission/Creation.vue')
    },
    {
      path: '/mission/creation',
      name: 'creation',
      component: () => import(/* webpackChunkName: "creation" */ './views/Mission/Creation.vue')
    },
    {
      path: '/en/mission/partnership',
      name: 'partnership-en',
      component: () => import(/* webpackChunkName: "partnership" */ './views/en/Mission/Partnership.vue')
    },
    {
      path: '/mission/partnership',
      name: 'partnership',
      component: () => import(/* webpackChunkName: "partnership" */ './views/Mission/Partnership.vue')
    },
    {
      path: '/services',
      name: 'services',
      redirect: {
        name: 'companies'
      }
    },
    {
      path: '/en/services',
      name: 'services-en',
      redirect: {
        name: 'companies-en'
      }
    },
    {
      path: '/en/services/companies',
      name: 'companies-en',
      component: () => import(/* webpackChunkName: "companies" */ './views/en/Services/Companies.vue')
    },
    {
      path: '/services/companies',
      name: 'companies',
      component: () => import(/* webpackChunkName: "companies" */ './views/Services/Companies.vue')
    },
    {
      path: '/en/services/dialog',
      name: 'dialog-en',
      component: () => import(/* webpackChunkName: "dialog" */ './views/en/Services/Dialog.vue')
    },
    {
      path: '/services/dialog',
      name: 'dialog',
      component: () => import(/* webpackChunkName: "dialog" */ './views/Services/Dialog.vue')
    },
    {
      path: '/en/services/ecosystem',
      name: 'ecosystem-en',
      component: () => import(/* webpackChunkName: "ecosystem" */ './views/en/Services/Ecosystem.vue')
    },
    {
      path: '/services/ecosystem',
      name: 'ecosystem',
      component: () => import(/* webpackChunkName: "ecosystem" */ './views/Services/Ecosystem.vue')
    },
    {
      path: '/en/services/anticrisis',
      name: 'anticrisis-en',
      component: () => import(/* webpackChunkName: "anticrisis" */ './views/en/Services/Anticrisis.vue')
    },
    {
      path: '/services/anticrisis',
      name: 'anticrisis',
      component: () => import(/* webpackChunkName: "anticrisis" */ './views/Services/Anticrisis.vue')
    },
    {
      path: '/en/services/design',
      name: 'design-en',
      component: () => import(/* webpackChunkName: "design" */ './views/en/Services/Design.vue')
    },
    {
      path: '/services/design',
      name: 'design',
      component: () => import(/* webpackChunkName: "design" */ './views/Services/Design.vue')
    },
    {
      path: '/about',
      name: 'about',
      redirect: {
        name: 'individualism'
      }
    },
    {
      path: '/en/about',
      name: 'about-en',
      redirect: {
        name: 'individualism-en'
      }
    },
    {
      path: '/en/about/individualism',
      name: 'individualism-en',
      component: () => import(/* webpackChunkName: "individualism" */ './views/en/About/Individualism.vue')
    },
    {
      path: '/about/individualism',
      name: 'individualism',
      component: () => import(/* webpackChunkName: "individualism" */ './views/About/Individualism.vue')
    },
    {
      path: '/en/about/relations',
      name: 'relations-en',
      component: () => import(/* webpackChunkName: "relations" */ './views/en/About/Relations.vue')
    },
    {
      path: '/about/relations',
      name: 'relations',
      component: () => import(/* webpackChunkName: "relations" */ './views/About/Relations.vue')
    },
    {
      path: '/en/about/motion',
      name: 'motion-en',
      component: () => import(/* webpackChunkName: "motion" */ './views/en/About/Motion.vue')
    },
    {
      path: '/about/motion',
      name: 'motion',
      component: () => import(/* webpackChunkName: "motion" */ './views/About/Motion.vue')
    },
    {
      path: '/contacts',
      name: 'contacts',
      component: () => import(/* webpackChunkName: "contacts" */ './views/Contacts.vue')
    },
    {
      path: '/en/contacts',
      name: 'contacts-en',
      component: () => import(/* webpackChunkName: "contacts" */ './views/en/Contacts.vue')
    }
  ]
})
